import React from 'react';
import { Button as DSButton } from '@hausgold/designsystem';
import { DownloadFilled } from '@hausgold/designsystem/icons';
import { graphql } from 'gatsby';
import CopyToClipboard from './CopyToClipboardButton';
import Link from './Link';
import {
  analyticsTrack,
  EVENT_OBJECT,
  EVENT_VERB,
  eventBuilder,
} from '../utils/tracking';

// Mapping contentful values to design system values
const COLOR_MAP = {
  primary: 'blue',
  success: 'green',
  danger: 'red',
};

// Mapping contentful values to internal types.
const TYPE_MAP = {
  Default: 'default',
  Download: 'download',
};

// Defines the types props.
const TYPE_PROPS = {
  default: {},
  download: {
    leftIcon: <DownloadFilled />,
    /*
     * This causes the browser to download the file instead of opening it.
     * Only works for same-origin links, though.
     */
    download: true,
    target: '_blank',
  },
};

/**
 * Contentful button
 *
 * Provides a link element styled as button.
 * Content is provided by Contentful most of the time.
 */
const ContentfulButton = ({
  entry = {},
  eventName,
  eventParams = {},
  eventLabel = null,
  ...props
}) => {
  /*
   * If CF Button text contains 'zwischenablage' we overwrite the normal button behaviour with
   * the copy-to-clipboard one
   */
  if (entry?.title?.toLowerCase()?.includes('zwischenablage')) {
    return <CopyToClipboard copyText={entry.url} />;
  }

  const handleClick = () => {
    analyticsTrack({
      event:
        eventName || eventBuilder(EVENT_OBJECT.button, EVENT_VERB.interacted),
      params: {
        label: (eventLabel || entry.title)?.trim(),
        to: entry.url,
        element_type: 'ContentfulButton',
        ...eventParams,
      },
    });
  };

  return (
    <DSButton
      colorScheme={COLOR_MAP[entry.color]}
      shadow={!!entry.shadow && 'lg'}
      size={entry.size === 'small' ? 'sm' : 'md'}
      as={Link}
      to={entry.url}
      onClick={handleClick}
      {...(TYPE_PROPS[TYPE_MAP[entry.type]] || {})}
      {...props}
    >
      {entry.title}
    </DSButton>
  );
};

export const query = graphql`
  fragment ContentfulButtonFragment on ContentfulButton {
    internal {
      type
    }
    id
    color
    shadow
    size
    title
    url
    type
  }
`;

export default ContentfulButton;
